<ng-container *ngIf="showData">
    <div class="col-12 my-4">
        <mat-card class="card-print">
            <mat-card-header>
                <mat-card-title class="font-size-title-card">
                    <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                    <strong>{{data?.title || ''}}</strong>
                </mat-card-title>
            </mat-card-header>
            
            <mat-card-content>

                <div class="row p-5">
                    <ng-container *ngFor="let tabla of data?.tables; let i = index">
                        <div class="col-12 mx-auto">
                            <div class="table-responsive border p-3" 
                                [class.border-bottom-0]="(i + 1) != data?.tables.length" 
                                [class.border-top-0]="i != 0"
                            >
                                <table mat-table [dataSource]="tabla?.rows" class="info-basica-table">
    
                                    <ng-container *ngFor="let item of tabla?.columns; let i = index">
                                        
                                        <ng-container *ngIf="item == 'label'; else elseTemplate">
                                            <ng-container [matColumnDef]="item">
                                                <th mat-cell *matCellDef="let element" class="cell-font-size" width="30%">
                                                    <span [ngClass]="element?.classLabel">
                                                        {{element.label || ''}}
                                                    </span>
                                                </th>
                                            </ng-container>
                                        </ng-container>
                                        <ng-template #elseTemplate>
                                            
                                            <ng-container [matColumnDef]="item">
                                                <td mat-cell *matCellDef="let element" class="cell-font-size" 
                                                    [attr.colspan]="element?.colspan ? element?.colspan : 1" 
                                                    [class.d-none]="!element.hasOwnProperty(item)"
                                                >
                                                    <div class="row w-100">
                                                        <div class="col-12">
                                                            <span 
                                                                [ngClass]="(element?.classValue && element[item]) ? element?.classValue : ''" 
                                                                [class.text-wrap]="element?.types[item] != 'rut'"
                                                                [class.fw-bolder]="element?.isStrong == true"
                                                            >
                                                                <ng-container *ngTemplateOutlet="dataTemplate; context: { $implicit: {type: element?.types[item], value: element[item]} }"></ng-container>
                                                            </span>
                                                        </div>
                                                        <div class="col-12" *ngIf="element?.extraSpan">
                                                            <span class=" campo-cursiva">
                                                                <ng-container *ngTemplateOutlet="dataTemplate; context: { $implicit: {type: 'string', value: element?.extraSpan} }"></ng-container>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                            </ng-container>
                                        </ng-template>
                                        
                                    </ng-container>
                                    
                                    <tr
                                        mat-row
                                        *matRowDef="let row; columns: tabla?.columns;"
                                    ></tr>
                                </table>
                            </div>
                        </div>
                    </ng-container>
                </div>

            </mat-card-content>
        </mat-card>
    </div>
</ng-container>

<ng-template #dataTemplate let-elemento>
    <ng-container [ngSwitch]="elemento?.type">
        <ng-container *ngSwitchCase="'rut'">
            {{elemento?.value ? (elemento?.value | rutFormat) : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'date'">
            {{elemento?.value ? (elemento?.value | date: 'dd-MM-yyyy') : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'int'">
            {{elemento?.value || elemento?.value == 0 ? (elemento?.value | number: '1.0-0') : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'porc'">
            {{elemento?.value || elemento?.value == 0 ? (elemento?.value | number: '1.0-2') : ''}}
        </ng-container>
        <ng-container *ngSwitchDefault>
            {{elemento?.value}}
        </ng-container>
    </ng-container>
</ng-template>
